import React from "react";
import ModalSideBar from "../../../../../components/ModalSideBar";
import { formatDateTimeBR } from "../../../../../helpers/format";
import { resolveTipoMovimentacao } from "../tipoMovimentacao";
import { ICaixaGeral } from "../types/types";

interface Props {
  data?: ICaixaGeral;
  onClose: () => void;
  title: string;
}

const Info: React.FC<Props> = (props: Props) => {
  const formatCurrency = (value: number | undefined) => {
    if (value === undefined || value === null) return "---";
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value);
  };

  return (
    <ModalSideBar isOpen title={props.title} onClose={props.onClose}>
      <div className="w-full h-full p-4">
        <div className="w-full grid grid-cols-1 gap-4">
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              ID
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.id_financeiro_caixa_geral ?? "---"}
            </span>
          </div>

          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">Total no Cofre</span>
            <span className="text-sm text-[#666666] font-normal">
              {formatCurrency(props.data?.total_no_cofre)}
            </span>
          </div>

          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">Tipo</span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data ? resolveTipoMovimentacao(props.data).label : "---"}
            </span>
          </div>

          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">Valor da Movimentação</span>
            <span className="text-sm text-[#666666] font-normal">
              {formatCurrency(props.data?.valor_movimentacao)}
            </span>
          </div>

          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">Justificativa</span>
            <span className="text-sm text-[#666666] font-normal whitespace-pre-wrap">
              {props.data?.justificativa ? props.data.justificativa : "---"}
            </span>
          </div>

          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">Usuário</span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.usuario ? props.data.usuario : "---"}
            </span>
          </div>

          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">Data Histórico</span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.data_historico ? formatDateTimeBR(props.data.data_historico) : "---"}
            </span>
          </div>
        </div>
      </div>
    </ModalSideBar>
  );
};

export default Info;
